import { render, staticRenderFns } from "./LocalType.vue?vue&type=template&id=73a9c0c2&scoped=true&"
import script from "./LocalType.vue?vue&type=script&lang=js&"
export * from "./LocalType.vue?vue&type=script&lang=js&"
import style0 from "./LocalType.vue?vue&type=style&index=0&id=73a9c0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a9c0c2",
  null
  
)

export default component.exports